import { useState, useEffect , useContext} from 'react';
import DataContext from '../../Context';
import { IPolicy } from '../../Models/PolicyInfo';

const useSaifFetch = <T,>(url: string, body: object, saifFetch: (url: string, jwtToken: string, body: object) => Promise<any>) => {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [status, setStatus] = useState<number | null>(null);

    const { jwtToken } = useContext(DataContext) as IPolicy;

    useEffect(() => {
        async function sendRequest() {
            setStatus(null);
            setLoading(true);
            setError(false);

            let response: Response;
            let responseBody: T | null = null;

            try {
                response = await saifFetch(url, jwtToken, body);
                try {
                    responseBody = await response.json();
                }
                catch {
                    responseBody = null;
                }

                if (response.status >= 401) {
                    setError(true);
                    setLoading(false);
                    setData(null)
                    setStatus(response.status)
                }
                else {
                    setLoading(false);
                    setError(false);
                    setData(responseBody);
                    setStatus(response.status);
                }
            } catch(e) {
                console.log("useSaifFetch Error:", e);
                setLoading(false);
                setError(true);
                setData(null);
            }
        }

        if (Object.entries(body).length) {
            sendRequest();
        }
    }, [url, body]);

    return { data, loading, error, status };
}

export default useSaifFetch;